import { render, staticRenderFns } from "./ShareFilesForm.vue?vue&type=template&id=3242bd2e&scoped=true"
import script from "./ShareFilesForm.vue?vue&type=script&lang=js"
export * from "./ShareFilesForm.vue?vue&type=script&lang=js"
import style0 from "./ShareFilesForm.vue?vue&type=style&index=0&id=3242bd2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3242bd2e",
  null
  
)

export default component.exports